<script lang="ts" module>
  import type { Snippet } from 'svelte';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';
  import type { ColorVariant } from '@agapi/ui/types';
  export type CampaignBadgeProps = {
    /** Custom CSS styles for the component */
    css?: SystemStyleObject;
    /** The content to be displayed inside the badge */
    children?: Snippet;
    /** The size of the badge */
    size?: 'sm' | 'md' | 'lg';
    /** The color variant of the badge */
    colorVariant?: ColorVariant;
  };
</script>


<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { dynamicColorString } from '@agapi/ui/panda/utils';
  import { badgeStyles } from './campaign-badge.styles';

  const { css: cssProp, children, size, colorVariant = "campaign" }: CampaignBadgeProps = $props();
</script>

<div class={css(badgeStyles.raw({ size }), cssProp)} style={dynamicColorString(colorVariant)}>
  {@render children?.()}
</div>

